"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const InvoiceTableHeader_1 = __importDefault(require("./InvoiceTableHeader"));
const InvoiceTableRow_1 = __importDefault(require("./InvoiceTableRow"));
const InvoiceTableBlankSpace_1 = __importDefault(require("./InvoiceTableBlankSpace"));
const InvoiceTableFooter_1 = __importDefault(require("./InvoiceTableFooter"));
const tableRowsCount = 5;
const styles = renderer_1.StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 32,
        borderWidth: 1,
        borderColor: '#e0f3fa',
    },
});
const InvoiceItemsTable = ({ invoice }) => (react_1.default.createElement(renderer_1.View, { style: styles.tableContainer },
    react_1.default.createElement(InvoiceTableHeader_1.default, null),
    react_1.default.createElement(InvoiceTableRow_1.default, { items: invoice.items }),
    react_1.default.createElement(InvoiceTableBlankSpace_1.default, { rowsCount: tableRowsCount - invoice.items.length }),
    react_1.default.createElement(InvoiceTableFooter_1.default, { items: invoice.items })));
exports.default = InvoiceItemsTable;
